var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "assets",
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 28 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 8 } }, [
            _c("div", { staticClass: "common-card" }, [
              _c("div", { staticClass: "common-card-main" }, [
                _c(
                  "div",
                  {
                    staticClass: "spaceLeft card-text-1",
                    staticStyle: {
                      "margin-bottom": "0.2rem",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("i", { staticClass: "iconfont trn-balance" }),
                        _vm._v(
                          "\n              Max borrowable amount\n              "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content:
                                "Based on your recent TAT minting records,this is the maximum TCash you can borrow.",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: {
                                "font-size": "0.16rem",
                                color: "#929DAD",
                                "margin-left": "0.08rem",
                                cursor: "pointer",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "0.16rem",
                          color: "#225BFC",
                          "margin-left": "0.1rem",
                          cursor: "pointer",
                        },
                        on: { click: _vm.handleLearnMore },
                      },
                      [_vm._v("\n              Learn more\n            ")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-text-2" }, [
                  _c(
                    "span",
                    [
                      !_vm.isEligible
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#FFFFFF",
                                "font-size": "0.24rem",
                              },
                            },
                            [_vm._v("Not eligible")]
                          )
                        : _c("big-number", {
                            attrs: { number: _vm.balance.PCL, count: 2 },
                            on: {
                              "update:number": function ($event) {
                                return _vm.$set(_vm.balance, "PCL", $event)
                              },
                            },
                          }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 8 } }, [
            _c("div", { staticClass: "common-card" }, [
              _c("div", { staticClass: "common-card-main" }, [
                _c(
                  "div",
                  {
                    staticClass: "spaceLeft card-text-1",
                    staticStyle: {
                      "margin-bottom": "0.2rem",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "0.24rem",
                            "margin-right": "0.1rem",
                          },
                          attrs: {
                            src: require("@/assets/image/profile/RemainingBorrowableAmount.png"),
                          },
                        }),
                        _vm._v(
                          "\n              Remaining borrowable amount\n              "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "Max borrowable-Outstanding",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: {
                                "font-size": "0.16rem",
                                color: "#929DAD",
                                "margin-left": "0.08rem",
                                cursor: "pointer",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-text-2" }, [
                  _c(
                    "span",
                    [
                      _c("big-number", {
                        attrs: { number: _vm.balance.ALB, count: 2 },
                        on: {
                          "update:number": function ($event) {
                            return _vm.$set(_vm.balance, "ALB", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 8 } }, [
            _c("div", { staticClass: "common-card" }, [
              _c("div", { staticClass: "common-card-main" }, [
                _c(
                  "div",
                  {
                    staticClass: "spaceBetween",
                    staticStyle: {
                      "margin-bottom": "0.2rem",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("div", { staticClass: "spaceLeft card-text-1" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              width: "0.24rem",
                              "margin-right": "0.1rem",
                            },
                            attrs: {
                              src: require("@/assets/image/profile/TotalUnrepaid.png"),
                            },
                          }),
                          _vm._v(
                            "\n                Total Unrepaid\n                "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content:
                                  "All your outstanding loans,including principal and interest excluding any excluding any repaid amount.",
                                placement: "top",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question",
                                staticStyle: {
                                  "font-size": "0.16rem",
                                  color: "#929DAD",
                                  "margin-left": "0.08rem",
                                  cursor: "pointer",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-text-2" }, [
                  _c(
                    "span",
                    [
                      _c("big-number", {
                        attrs: { number: _vm.calculateTLAMinusTRA(), count: 2 },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showDueLoans
                    ? _c("span", [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#D71817",
                              "font-size": "0.16rem",
                              "margin-left": "0.12rem",
                              "margin-right": "0.07rem",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.dueLoansCount) +
                                " loans due\n                soon"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#FFFFFF",
                              "font-size": "0.16rem",
                            },
                          },
                          [
                            _vm._v(
                              "\n                Please\n                "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "repay-now-btn",
                                staticStyle: {
                                  color: "#225BFC",
                                  "font-size": "0.16rem",
                                  cursor: "pointer",
                                  "text-decoration": "underline",
                                  "font-weight": "600",
                                  padding: "0.04rem 0.08rem",
                                  transition: "all 0.3s ease",
                                },
                                on: {
                                  click: _vm.goToRepayPage,
                                  mouseover: function ($event) {
                                    $event.target.style.backgroundColor =
                                      "rgba(34, 91, 252, 0.1)"
                                  },
                                  mouseout: function ($event) {
                                    $event.target.style.backgroundColor =
                                      "transparent"
                                  },
                                },
                              },
                              [_vm._v("repay now.")]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.account
            ? _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-around",
                    width: "100%",
                  },
                  attrs: { xs: 24, sm: 24, md: 8, lg: 8 },
                },
                [
                  _c("div", { staticClass: "echat" }, [
                    _c("div", {
                      ref: "loanStatusChart",
                      staticStyle: { width: "100%", height: "4.5rem" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "echat" }, [
                    _c("div", {
                      ref: "balanceChart",
                      staticStyle: { width: "100%", height: "4.5rem" },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "8rem",
            "custom-class": "learn-more-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "dialog-custom-title" }, [
              _vm._v(_vm._s(_vm.learnMoreTitle)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "learn-more-content" }, [
            _vm._v("\n      " + _vm._s(_vm.learnMoreText) + "\n\n\n      "),
            _vm.learnMoreTitle == "Value Source"
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#225BFC",
                        "margin-top": "0.2rem",
                        "font-weight": "600",
                      },
                    },
                    [_vm._v("How is credit measured?")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#225BFC",
                        "margin-top": "0.1rem",
                        "font-weight": "600",
                      },
                    },
                    [
                      _vm._v(
                        "How is the max borrowable amount calculated?\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#225BFC",
                        "margin-top": "0.1rem",
                        "font-weight": "600",
                      },
                    },
                    [_vm._v("Learn more details ")]
                  ),
                ])
              : _c("div", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#225BFC",
                        "margin-top": "0.2rem",
                        "font-weight": "600",
                      },
                    },
                    [_vm._v("How to mint Rep？")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#225BFC",
                        "margin-top": "0.1rem",
                        "font-weight": "600",
                      },
                    },
                    [_vm._v("Learn more details ")]
                  ),
                ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }